// src/components/SubTask.tsx
import React from 'react';
import { Typography, Card, Box } from '@mui/material';
import NoImageFound from '../../../src/no_image_found.png'

interface SubTaskProps {
  question_id: string;
  question_en: string;
  sample_picture:string;
  task_question_answer: any;
}

const SubTask: React.FC<SubTaskProps> = ({ question_id,
  sample_picture,
  question_en,
  task_question_answer }) => {
  return (
    <Box sx={{ width: "100%", display: "flex", gap: "16px", marginBottom: "32px" }}>
      <Box sx={{ width: "50%" }}>
        <Card sx={{ border: "0", boxShadow: 'none', background: "#F5F5F5", borderRadius: "8px  8px 16px 16px", width: "100%", }}>
          <Typography sx={{ fontSize: "12px", lineHeight: "14.52px", fontWeight: "600", color: "#1D2939", padding: "10px 12px" }}>
            {/* {question_en} */}
            Sample Picture 1 : {question_en}
          </Typography>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", padding: "22px 0" }}>
            <img crossOrigin='anonymous'
              src={`${process.env.REACT_APP_API_URL}${sample_picture}` || NoImageFound}
              alt={question_en} style={{ width: '100%', height: '220px',  margin: "0 auto", }} />
          </Box>
        </Card>
      </Box>

      <Box sx={{ width: "50%" }}>
        <Card sx={{ border: "0", boxShadow: 'none', background: "#6D6D6D", borderRadius: "8px  8px 16px 16px", }}>
          <Typography sx={{ fontSize: "12px", lineHeight: "14.52px", fontWeight: "600", color: "#FFFFFF", padding: "10px 12px" }}>
            Uploaded Picture 1 : {question_en}
          </Typography>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <img crossOrigin='anonymous' src={task_question_answer?.answer || NoImageFound} alt={question_en} style={{ width: '100%', height: '264px', margin: "0 auto", objectFit:'contain' }} />
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default SubTask;
